<div class="page">
  <kgrid class="griddetail" [hideToolber]="true" [columns]="columns"> </kgrid>
</div>
